import React from "react";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import { all_routes } from "../feature-module/router/all_routes";
import { useEffect, useState } from "react";
import "../style/css/custom.css";
import { getUserLoginData } from "../core/data/redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatbotFloatingButton from "../core/common/chatbotFloatingButton";
import { getApplicationModulesAPI } from "../core/data/redux/applicationModulesSlice";
import { getStaffQuarterPermissions, getStaffQuarterAdminPermissions } from "../core/data/redux/staffQuarterSlice";
import { tokenService } from "../core/utils/tokenService";



const AdminFeature = () => {

  const token = tokenService.getToken() || "";
  const user: any = localStorage.getItem("user");
  const userJson = user && user != 'undefined' ? JSON.parse(user) : {};

  let userType: any = userJson?.user_type || userJson?.role;

  const dispatch = useDispatch();
  const location = useLocation();
  const pagePath = location.pathname
    .slice(1) // remove leading slash
    .split('/')
    .filter((segment: any) => isNaN(segment)) // remove numeric parts
    .join('/');



  const routes = all_routes;

  const { data: applicationModulesResponse, loading } = useSelector((state: any) => state.applicationModulesState || {});
  const { permissions: sqPermissions, adminPermissions, loading: sqLoading } = useSelector((state: any) => state.staffQuarterState || {});

  React.useEffect(() => {
    dispatch(getUserLoginData({}));
  }, []);

  useEffect(() => {
    if (loading === "idle") {
      dispatch(getApplicationModulesAPI({ page: 1, limit: 100, orderColumn: "name", orderBy: "ASC" }));
    }
  }, [dispatch, loading]);

  useEffect(() => {
    const token = tokenService.getToken() || "";
    if (token && sqLoading === "idle") {
      dispatch(getStaffQuarterPermissions({}));
      dispatch(getStaffQuarterAdminPermissions({}));
    }
  }, [dispatch, sqLoading]);

  //const privatePages = ['office-location', 'work-shift'];

  useEffect(() => {

    let allowedPermissions: any = [];

    if (localStorage.getItem('allowed_permissions') != undefined && localStorage.getItem('allowed_permissions') != 'undefined') {
      allowedPermissions = JSON.parse(localStorage.getItem('allowed_permissions') || '[]');
    }



    if (!token) {
      return window.location.replace(routes.login);
    } else if (userType == "EMPLOYEE") {
      if (!allowedPermissions.includes(pagePath))
        return window.location.replace(routes.employeeDashboard);
    }

  });


  const headerCollapse = useSelector((state: any) => state.themeSetting.headerCollapse);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state: any) => state.sidebarSlice.miniSidebar
  );
  const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector((state: any) => state.themeSetting.dataSidebarAll);
  const dataColorAll = useSelector((state: any) => state.themeSetting.dataColorAll);
  const dataTopBarColorAll = useSelector((state: any) => state.themeSetting.dataTopBarColorAll);
  const dataTopbarAll = useSelector((state: any) => state.themeSetting.dataTopbarAll);

  useEffect(() => {
    if (dataTheme === "dark_data_theme") {
      document.documentElement.setAttribute("data-theme", "darks");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
       ${dataLayout === "mini" || dataWidth === 'box' ? "mini-sidebar" : ''}
       ${dataLayout === "horizontal" || dataLayout === "horizontal-single" || dataLayout === "horizontal-overlay" || dataLayout === "horizontal-box" ? 'menu-horizontal' : ''}
      ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
      ${dataWidth === 'box' ? 'layout-box-mode' : ''} ${headerCollapse ? "header-collapse" : ""}
     ${(expandMenu && miniSidebar) ||
            (expandMenu && dataLayout === "mini")
            ? "expand-menu"
            : ""
          }
      
      `}
      >
        <div
          className={`main-wrapper 
            ${mobileSidebar ? "slide-nav" : ""}`}
        >
          <Header />
          <Sidebar />
          <Outlet />
        </div>

        <div className="sidebar-overlay"></div>

        {/* Toast Container for react-toastify */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {/* Floating Chatbot Button */}
        {
          userType == "EMPLOYEE" && (
            <>
              <ChatbotFloatingButton />
            </>
          )
        }
      </div>
    </>
  );
};

export default AdminFeature;
